import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import {
  compact,
  get,
  noop,
  orderBy,
} from 'lodash';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CircularProgress from '@material-ui/core/CircularProgress';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp';
import Delete from '@material-ui/icons/Delete';
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown';
import Pending from '@material-ui/icons/NewReleases';
import { grey700, green, red } from '@material-ui/core/colors';
import LocalShipping from '@material-ui/icons/LocalShipping';
import Group from '@material-ui/icons/Group';

import immutableToJS from 'helpers/immutableToJS';
import {
  dispatchRestMaker,
  formatPhoneNumber,
  formatPrice,
  getOrderStatus,
  scrollTo,
} from 'helpers/utils';
import { isMobile } from 'helpers/detect-mobile';
import {
  Avatar,
  Badge,
  ConfirmAction,
  HighlightText,
  injectIntl,
  InvoiceBadge,
  ProfileBanner,
  Tooltip,
} from 'components';
import { CardBioContent } from 'components/Card';
import SelectField from 'components/SmartForm/components/SelectField';
import ROLE_IDS from 'constants/roleIds';
import { FRInput } from 'elements';
import { buyersAcceptActions } from 'redux/buyers/actions';
import ordersActions from 'redux/orders/actions';
import { sellersAcceptActions } from 'redux/sellers/actions';
import { selectState } from 'redux/selectors';
import { contactsReinviteActions } from 'redux/contacts/actions';
import ContactCardDetail from './ContactCardDetail';

const styles = theme => ({
  cardAction: {
    borderRadius: '50% !important;',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;',
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  cardHeaderRoot: {
    paddingTop: 5,
    paddingBottom: 5,
    [theme.breakpoints.down('sm')]: {
      padding: '5px 5px',
    },
  },
  cardHeader: {
    paddingRight: 0,
    width: '100%',
    padding: '10px',
  },
  cardMedia: { position: 'relative' },
  groupsSelectRoot: {
    height: 45,
    marginTop: -18,
    minWidth: 70,
  },
  netModeSelectRoot: {
    height: 45,
    marginTop: -18,
    minWidth: 120,
  },
  netModeSelect: {
    minWidth: 70,
    marginRight: 5,
  },
  groupsSelectLabel: { fontSize: 12 },
  netModeSelectLabel: { fontSize: 11, textTransform: 'uppercase', fontWeight: 500 },
  groupsSelectItem: { fontSize: 12 },
  netModeSelectItem: { fontSize: 11, textTransform: 'uppercase' },
  tiersSelectLabel: { top: -20 },
  tiersSelectRoot: {
    height: 30,
    marginTop: 10,
    width: 150,
  },
  selectMenu: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 50,
    },
  },
  netModeSelectMenu: {
    fontWeight: 'bold',
    width: 'auto',
  },
  netModeSelectMenuMobile: {
    fontWeight: 'bold',
    width: 90,
  },
  autoMenu: { color: '#4caf50' },
  netMenu: { color: '#4caf50' },
  manualMenu: { color: 'red' },
  iconShow: { opacity: 1 },
  iconHide: { opacity: 0 },
  textButtonLabel: {
    color: '#459dfe',
  },
});

class ContactCard extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    contact: PropTypes.shape({}).isRequired,
    contactRequesting: PropTypes.bool,
    expanded: PropTypes.bool,
    globals: PropTypes.arrayOf(PropTypes.shape({})),
    info: PropTypes.shape({
      id: PropTypes.number,
      bio: PropTypes.string,
      companyName: PropTypes.string,
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      userCoverImage: PropTypes.string,
      userCategory: PropTypes.string,
    }).isRequired,
    isRest: PropTypes.bool,
    isVendor: PropTypes.bool,
    order: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    orderRequesting: PropTypes.bool,
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    ordersRequesting: PropTypes.bool,
    searchText: PropTypes.string,
    userBroadCastGroups: PropTypes.arrayOf(
      PropTypes.string,
    ).isRequired,

    createBuyersAccept: PropTypes.func.isRequired,
    createSellersAccept: PropTypes.func.isRequired,
    createContactReinvite: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    listOrders: PropTypes.func.isRequired,
    onCreateContact: PropTypes.func.isRequired,
    onRemoveContact: PropTypes.func.isRequired,
    onUpdateContact: PropTypes.func.isRequired,
    readOrder: PropTypes.func.isRequired,
    reload: PropTypes.func.isRequired,
    setExpanded: PropTypes.func,
    updateOrder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    contactRequesting: false,
    expanded: false,
    globals: [],
    isRest: false,
    isVendor: false,
    orderRequesting: false,
    ordersRequesting: false,
    searchText: '',
    setExpanded: noop,
  };

  static contextTypes = {
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    noAutoPay: PropTypes.bool,
    readOnly: PropTypes.bool,
    setHotNotification: PropTypes.func,
  };

  state = { discountInput: false, savedDeliveryFee: -1 };

  componentWillMount() {
    const { expanded } = this.props;
    if (expanded) this.handleExpandChange(expanded);
  }

  componentWillReceiveProps({ expanded }) {
    if (expanded && !this.props.expanded) {
      this.handleExpandChange(expanded);
    }
  }

  accept = () => {
    const {
      contact,
      createBuyersAccept,
      createSellersAccept,
      isVendor,
      reload,
    } = this.props;

    if (isVendor) {
      createSellersAccept(contact.sellerId, {
        onSuccess: () => {
          reload();
        },
      });
    } else {
      createBuyersAccept(contact.buyerId, {
        onSuccess: () => {
          reload();
        },
      });
    }
  };

  activate = () => {
    const { info, onCreateContact } = this.props;
    onCreateContact({
      companyName: info.companyName,
      firstName: info.firstName,
      email: info.email,
      lastName: info.lastName,
    });
  }

  resend = () => {
    const { contact, createContactReinvite } = this.props;
    createContactReinvite(contact.id);
  };

  editContactInfo = () => {
    this.handleEditContactInfoDlgOpen();
  };

  expandChange = (expanded) => {
    const { info, setExpanded } = this.props;
    setExpanded(!expanded ? info.id : -1);
  };

  handleExpandChange = (expanded) => {
    const {
      info,
      isRest,
      isVendor,
      listOrders,
    } = this.props;

    if (!expanded) return;

    if (isVendor || isRest) {
      listOrders({ sellerId: info.id });
    } else {
      listOrders({ buyerId: info.id });
    }

    setTimeout(() => scrollTo(`customer-${info.id}`), 100);
  };

  handleGroupChange = (value) => {
    const { info, isVendor, onUpdateContact } = this.props;
    const newValue = value || null;
    onUpdateContact(info.id, {
      [isVendor ? 'sellerGroupName' : 'buyerGroupName']: newValue,
    });
  };

  handleNetModeChange = (value) => {
    const { info, contact, onUpdateContact } = this.props;
    const isOriginalOffline = contact.netMode.startsWith('manual-');
    const isOffline = value.startsWith('manual-');
    onUpdateContact(info.id, {
      netMode: value,
      payMode: isOffline && !isOriginalOffline ? 'coin' : !isOffline && isOriginalOffline ? 'all' : contact.payMode,
    });
  };

  handlePayModeChange = (value) => {
    const { info, onUpdateContact } = this.props;
    onUpdateContact(info.id, {
      payMode: value,
    });
  };

  validateDiscount = (event) => {
    const { setHotNotification } = this.context;
    event.preventDefault();
    const { target: { value } } = event;
    if (parseFloat(value || 0) < 0) {
      setHotNotification('Should not be less than 0');
      event.target.value = '';
    }
  };

  updateDiscount = (discount, inputField = true) => {
    const { contact } = this.props;
    if (discount === 'custom') {
      this.setState({ discountInput: true }, () => {
        setTimeout(() => {
          this.discountInput.focus();
        }, 0);
      });
      return;
    }
    const { info, onUpdateContact } = this.props;
    if (parseInt(discount, 0) >= 0) {
      if (parseInt(discount, 0) !== contact.defaultDiscount) {
        onUpdateContact(info.id, { defaultDiscount: parseInt(discount, 10) });
      }
    }

    if (!inputField) {
      this.setState({ discountInput: false });
    }
  };

  validateDeliveryFee = (event) => {
    const { setHotNotification } = this.context;
    const { target: { value } } = event;
    const { globals, info, formatMessage, onUpdateContact } = this.props;
    const maxDeliveryFeeGlobal = globals.find(g => g.name === 'maxDeliveryFee') || {};
    const maxDeliveryFee = maxDeliveryFeeGlobal.value || 0;
    const fValue = parseFloat(value);

    if (fValue > maxDeliveryFee) {
      setHotNotification(formatMessage('BEYOND_MAX_DELIVERY_FEE'));
      event.target.value = '';
      return;
    }
    if (fValue < 0) {
      setHotNotification(formatMessage('Should not be less than 0'));
      event.target.value = '';
      return;
    }
  }

  updateDeliveryFeeOnBlur = (event) => {
    const { target: { value } } = event;
    const { setHotNotification } = this.context;
    const { globals, info, formatMessage, onUpdateContact } = this.props;
    const maxDeliveryFeeGlobal = globals.find(g => g.name === 'maxDeliveryFee') || {};
    const maxDeliveryFee = maxDeliveryFeeGlobal.value || 0;
    const fValue = parseFloat(value);

    if (value == '') {
      event.target.value = this.state.savedDeliveryFee >= 0 ? this.state.savedDeliveryFee : event.target.defaultValue;
      return;
    } else {
      if (fValue > maxDeliveryFee) {
        setHotNotification(formatMessage('BEYOND_MAX_DELIVERY_FEE'));
        return;
      }
      if (fValue < 0) {
        setHotNotification(formatMessage('Should not be less than 0'));
        return;
      }
  
      onUpdateContact(info.id, { defaultDeliveryFee: parseFloat(value, 10) });
      this.setState({ savedDeliveryFee: parseFloat(value, 10)});
    }
  }

  updateDeliveryFee = (value) => {
    const { setHotNotification } = this.context;
    const { globals, info, formatMessage, onUpdateContact } = this.props;
    const maxDeliveryFeeGlobal = globals.find(g => g.name === 'maxDeliveryFee') || {};
    const maxDeliveryFee = maxDeliveryFeeGlobal.value || 0;
    const fValue = parseFloat(value);

    if (fValue > maxDeliveryFee) {
      setHotNotification(formatMessage('BEYOND_MAX_DELIVERY_FEE'));
      return;
    }
    if (fValue < 0) {
      setHotNotification(formatMessage('Should not be less than 0'));
      return;
    }

    onUpdateContact(info.id, { defaultDeliveryFee: parseFloat(value, 10) });
    this.setState({ savedDeliveryFee: parseFloat(value, 10)});
  }

  updateCompanyCode = (companyCode) => {
    const { info, contact, isVendor, onUpdateContact } = this.props;
    const companyCodeKey = isVendor ? 'sellerCompanyCode' : 'buyerCompanyCode';
    if (companyCode !== contact[companyCodeKey]) {
      onUpdateContact(info.id, { [companyCodeKey]: companyCode });
    }
  };

  updateNote = (note) => {
    const { info, contact, isVendor, onUpdateContact } = this.props;
    const noteKey = isVendor ? 'sellerNote' : 'buyerNote';
    if (note !== contact[noteKey]) {
      onUpdateContact(info.id, { [noteKey]: note });
    }
  }

  removeContactInfo = () => {
    const { contact, onRemoveContact } = this.props;
    onRemoveContact(contact.id);
  };

  toggleForAllowManualPay = (on) => {
    const { info, onUpdateContact } = this.props;
    onUpdateContact(info.id, { allowManualPay: on });
  };

  renderCardContent = (isVendorRoute, companyCode, lengthOfMembers, avatar) => {
    const {
      readOnly,
      isConsumer,
    } = this.context;

    const {
      classes,
      contact,
      contactRequesting,
      formatMessage,
      info,
      order,
      orderRequesting,
      orders,
      ordersRequesting,
      readOrder,
      updateOrder,
    } = this.props;

    const {
      discountInput,
    } = this.state;

    const note = isVendorRoute ? contact.sellerNote : contact.buyerNote;
    const discount = contact.defaultDiscount || 0;
    const isDistributor = get(contact, 'buyerProfile.roleId') === ROLE_IDS.DISTRIBUTOR;
    const deliveryFee = contact.defaultDeliveryFee || 0;
    const isConsumerOff = contact.sellerProfile.isConsumerOff !== undefined ? contact.sellerProfile.isConsumerOff : true;
    const isDeactivated = contact.isDeleted || (contact.sellerProfile.isOff && !isConsumer) || (isConsumerOff && isConsumer);
    const sortedOrders = orderBy(orders, 'deliveryDate', 'desc').map(order => ({
      ...order,
      orderStatus: getOrderStatus(order),
      badge: getOrderStatus(order) === 'Paid' ? '-' : getOrderStatus(order),
    }));

    const circularProgress = ordersRequesting && (
      <div className="customer-progress">
        <CircularProgress />
      </div>
    );

    const invoiceHistory = (
      <div style={{ padding: 10 }}>
        <span className="invoice-list-header">
          {!isConsumer && <div className="header-label">{formatMessage('Invoice Archive')} - {info.companyName}</div>}
          {Number(contact.unpaidBalance) > 0 && (
            <div className="unpaid-balance">
              {formatMessage('Unpaid Balance')} = <span style={{ color: 'red' }}>${formatPrice(contact.unpaidBalance)}</span>
            </div>
          )}
        </span>
        {sortedOrders ?
          <ContactCardDetail
            avatar={avatar}
            isDeleted={contact.isDeleted === true}
            isVendor={isVendorRoute}
            order={order}
            orderRequesting={orderRequesting}
            readOrder={readOrder}
            sortedOrders={sortedOrders}
            updateOrder={updateOrder}
          /> : ''
        }
      </div>
    );
    const hasAddresses = info.addresses && info.addresses.length > 0;
    const contactDetails = (
      <div className={`contact-detail ${isConsumer ? 'consumer' : ''}`}>
        {companyCode &&
          <p>{`Code: ${companyCode}`}
        </p>}
        <span>{hasAddresses ?
          `${info.addresses[0].address}, ` : ''}
        </span>
        <span>{hasAddresses ?
          `${info.addresses[0].city}, ` : ''}
        </span>
        <span>{hasAddresses ?
          `${info.addresses[0].state} ${info.addresses[0].zipcode ?
            `- ${info.addresses[0].zipcode}` : ''}` :
          ''}
        </span>
        <p>{info.email ?
          info.email : ''}
        </p>
        <p>{info.mobile ?
          formatPhoneNumber(info.mobile) : ''}
        </p>
      </div>
    );

    // Vendors page
    if (isVendorRoute) {
      return (
        <Fragment>
          <CardContent className="row contact-info">
            <div className="col-sm-6">
              {contactDetails}
            </div>
            {!isConsumer &&
            <div className="col-sm-6">
              <div style={{ color: 'gray' }}>{formatMessage('Write a Note:')}</div>
              <FRInput
                defaultValue={note}
                onBlur={({ target: { value } }) => {
                  if (note !== value) {
                    this.updateNote(value);
                  }
                }}
                onKeyPress={({ keyCode, which, target: { value } }) =>
                  (which === 13 || keyCode === 13) && this.updateNote(value)}
                style={{ marginTop: 7, marginRight: 5, fontSize: 18, width: '100%' }}
              />
            </div>}
            {!isConsumer &&
            <div className="col-sm-2 d-md-down-none">
              <div>
                <div>{formatMessage('Vendor Code')}</div>
                <FRInput
                  disabled={contact.isDeleted}
                  defaultValue={companyCode}
                  onBlur={({ target: { value } }) => this.updateCompanyCode(value)}
                  onKeyPress={({ keyCode, which, target: { value } }) =>
                    (which === 13 || keyCode === 13) && this.updateCompanyCode(value)}
                  style={{ marginTop: 7, marginRight: 5, fontSize: 18 }}
                />
              </div>
            </div>}
            <div className="col-sm-1 d-md-down-none">
              {!(isDeactivated || contact.requestorId) && (
                <ConfirmAction
                  action={this.removeContactInfo}
                  description={formatMessage('Do you really want to block this vendor?')}
                >
                  <Button
                    classes={{ label: classes.textButtonLabel }}
                    disabled={readOnly}
                  >
                    {formatMessage('Block')}
                  </Button>
                </ConfirmAction>
              )}
            </div>
          </CardContent>
          <CardContent style={{ padding: 0 }}>
            {circularProgress}
            {invoiceHistory}
          </CardContent>
        </Fragment>
      );
    }

    // Customers page
    return (
      <Fragment>
        <CardContent className="row">
          <div className="col-sm-4">
            <CardBioContent info={info} />
          </div>
          <div className="col-sm-8">
            <div style={{ color: 'gray' }}>{formatMessage('Write a Note:')}</div>
            <FRInput
              defaultValue={note}
              onBlur={({ target: { value } }) => {
                if (note !== value) {
                  this.updateNote(value);
                }
              }}
              onKeyPress={({ keyCode, which, target: { value } }) =>
                (which === 13 || keyCode === 13) && this.updateNote(value)}
              style={{ marginTop: 7, marginRight: 5, fontSize: 18, width: '100%' }}
            />
          </div>
        </CardContent>
        <CardContent style={{ padding: 0 }}>
          <div className="contact-info">
            {contactDetails}
            {Boolean(lengthOfMembers) && (
              <div>
                <strong>Members</strong>
                {
                  contact.buyerProfile.members.map((member, index) => (
                    <div key={index}>
                      {member.profile.firstName}&nbsp;{member.profile.lastName}&nbsp;&nbsp;<span style={{ color: 'gray' }}>{member.email}</span>
                    </div>
                  ))
                }
              </div>
            )}
            <div className="actions d-md-down-none">
              {/* Company Code */}
              <div>
                <div>{formatMessage('Company Code')}</div>
                <FRInput
                  disabled={contact.isDeleted}
                  defaultValue={companyCode}
                  onBlur={({ target: { value } }) => this.updateCompanyCode(value)}
                  onKeyPress={({ keyCode, which, target: { value } }) =>
                    (which === 13 || keyCode === 13) && this.updateCompanyCode(value)}
                  style={{ marginTop: 7, marginRight: 5, fontSize: 18, width: 150 }}
                />
              </div>

              {/* Discount */}
              {discountInput ? (
                <FRInput
                  defaultValue={discount}
                  disabled={readOnly || contact.isDeleted === true}
                  max={100}
                  min={0}
                  onChange={this.validateDiscount}
                  onBlur={({ target: { value } }) => this.updateDiscount(value, false)}
                  onKeyPress={({ keyCode, which, target: { value } }) =>
                    (which === 13 || keyCode === 13) && this.updateDiscount(value, false)}
                  ref={(c) => { this.discountInput = c; }}
                  style={{ padding: 5, fontSize: 18, width: 150 }}
                  type="number"
                />
              ) : (
                <div>
                  <span>{formatMessage('Set Discount Tiers')}</span>
                  <SelectField
                    classes={{
                      root: { root: classes.tiersSelectRoot },
                      select: {
                        select: classes.tiersSelectLabel,
                        icon: classes.selectIcon,
                      },
                    }}
                    disabled={readOnly || contactRequesting || contact.isDeleted === true}
                    fullWidth
                    key={discount}
                    name="group-list"
                    onChange={this.updateDiscount}
                    options={compact([
                      discount % 5 === 0 && discount < 20 && discount >= 0 ? null : { label: `${discount}%`, value: discount },
                      { label: 'None', value: 0 },
                      { label: '5%', value: 5 },
                      { label: '10%', value: 10 },
                      { label: '15%', value: 15 },
                      { label: 'Custom', value: 'custom' },
                      contactRequesting ? { label: '...', value: 'loading' } : null,
                    ])}
                    value={contactRequesting ? 'loading' : discount}
                  />
                </div>
              )}

              {/* Delivery Free */}
              <div style={{ marginLeft: 5 }}>
                <div>{formatMessage('Set Delivery Fee')}</div>
                <FRInput
                  defaultValue={deliveryFee}
                  disabled={readOnly || contactRequesting || contact.isDeleted === true}
                  onChange={this.validateDeliveryFee}
                  onBlur={this.updateDeliveryFeeOnBlur}
                  onKeyPress={({ keyCode, which, target: { value } }) =>
                    (which === 13 || keyCode === 13) && this.updateDeliveryFee(value)}
                  style={{ marginTop: 7, marginRight: 5, fontSize: 18, width: 150 }}
                  type="number"
                />
              </div>

              {/* Block button */}
              {!(contact.isDeleted || contact.requestorId) && (
                <ConfirmAction
                  action={this.removeContactInfo}
                  description={formatMessage('Do you really want to block this customer?')}
                >
                  <Button
                    classes={{ label: classes.textButtonLabel }}
                    disabled={readOnly}
                  >
                    {formatMessage('Block')}
                  </Button>
                </ConfirmAction>
              )}
            </div>
          </div>
          {circularProgress}
          {invoiceHistory}
        </CardContent>
      </Fragment>
    );
  };

  render() {
    const {
      classes,
      contact,
      contactRequesting,
      expanded,
      formatMessage,
      info,
      isVendor,
      searchText,
      userBroadCastGroups,
    } = this.props;
    const {
      noAutoPay,
      readOnly,
      isConsumer,
    } = this.context;

    const {
      discountInput,
    } = this.state;

    const companyCode = isVendor ? contact.sellerCompanyCode : contact.buyerCompanyCode;
    const discount = contact.defaultDiscount || 0;
    const deliveryFee = contact.defaultDeliveryFee || 0;
    const lengthOfMembers = get(contact, 'buyerProfile.members.length');
    const logoImage = info.logoUrl;
    const coverImage = info.coverImageUrl;
    const filteredBroadCastGroups = userBroadCastGroups
      .filter(groupName => groupName.startsWith(isVendor ? 'v-' : 'c-'))
      .map(groupName => groupName.substr('v-'.length));
    const userBroadCastGroupsList = filteredBroadCastGroups ?
      filteredBroadCastGroups.map(group => ({
        label: group,
        value: group,
      })) : [];
    userBroadCastGroupsList.unshift({
      label: 'None',
      value: '',
    });
    const isMe = (isVendor ? contact.requestorId === contact.buyerId :
      contact.requestorId === contact.sellerId);
    const avatar = (
      <Avatar
        fullName={info.companyName}
        src={logoImage}
        size={40}
      />
    );
    const styles = {
      cardPadding: {
        padding: '5px 0',
      },
      disable: {
        backgroundColor: '#e4e5e6',
      },
    };
    const buyerRoleId = contact.buyerProfile && contact.buyerProfile.roleId ? contact.buyerProfile.roleId : 0;
    const buyerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[buyerRoleId] || 'Personal';
    const isConsumerOff = contact.sellerProfile.isConsumerOff !== undefined ? contact.sellerProfile.isConsumerOff : true;
    const isDeactivated = contact.isDeleted || (contact.sellerProfile.isOff && buyerRole !== 'Consumer') || (isConsumerOff && buyerRole === 'Consumer');
    const cardCover = coverImage ? (
      <CardMedia
        classes={{ root: classes.cardMedia }}
        image={coverImage}
      >
        <ProfileBanner
          img={coverImage}
          userType={info.userCategory}
        />
      </CardMedia>
    ) : (
      <ProfileBanner
        img={coverImage}
        userType={info.userCategory}
      />
    );
    const netModeOptions = [
      // { labels: ['Auto Pay C.O.D'], value: 'auto' },
      // { labels: ['Auto Pay Net-7'], value: 'net-7' },
      // { labels: ['Auto Pay Net-15'], value: 'net-15' },
      // { labels: ['Auto Pay Net-21'], value: 'net-21' },
      // { labels: ['Auto Pay Net-30'], value: 'net-30' },
      { labels: ['C.O.D'], value: 'manual-cod' },
      { labels: ['Net-7'], value: 'manual-net-7' },
      { labels: ['Net-15'], value: 'manual-net-15' },
      { labels: ['Net-21'], value: 'manual-net-21' },
      { labels: ['Net-30'], value: 'manual-net-30' },
      // { labels: ['One Time Payment'], value: 'manual' },
    ].map(({ labels, subLabel, value }) => ({
      value,
      label: (
        <Fragment>
          {labels.map((label, index) => (
            <Fragment key={index}>
              {index > 0 && (
                <span style={{ fontSize: 9, color: 'gray', marginLeft: 3, marginRight: 3 }}>
                  or
                </span>
              )}
              {formatMessage(label)}
            </Fragment>
          ))}
          {subLabel && (
            <span style={{ fontSize: 9, color: 'gray', marginLeft: 3 }}>
              {formatMessage(subLabel)}
            </span>
          )}
        </Fragment>
      ),
    }));

    const offlinePay = contact.netMode.startsWith('manual-');

    const payModeOptions = compact([
      !offlinePay && { labels: ['ACH', 'CARD'], value: 'all' },
      !offlinePay && { labels: ['ACH'], value: 'ach' },
      !offlinePay && { labels: ['CARD'], value: 'card' },
      !offlinePay && { labels: ['Freshr Balance'], value: 'coin' },
      offlinePay && { labels: ['Check', 'Cash'], value: 'coin' },
    ]).map(({ labels, subLabel, value }) => ({
      value,
      label: (
        <Fragment>
          {labels.map((label, index) => (
            <Fragment key={index}>
              {index > 0 && (
                <span style={{ fontSize: 9, color: 'gray', marginLeft: 3, marginRight: 3 }}>
                  or
                </span>
              )}
              {formatMessage(label)}
            </Fragment>
          ))}
          {subLabel && (
            <span style={{ fontSize: 9, color: 'gray', marginLeft: 3 }}>
              {formatMessage(subLabel)}
            </span>
          )}
        </Fragment>
      ),
    }));
    const showPaymentMethodDropDown = false;
    return (
      <Element
        name={`customer-${info.id}`}
        style={{ padding: '5px 0' }}
      >
        <Card style={isDeactivated || contact.requestorId ? styles.disable : {}}>
          <CardHeader
            classes={{
              root: classes.cardHeaderRoot,
              content: classes.cardHeader,
              action: classes.cardAction,
            }}
            title={
              <div className="container-fluid pl-0 pr-0">
                <div className="store-card-title mr-1 d-flex">
                  {/* Avatar */}
                  <div className="d-flex align-items-center col-md-4 no-padding">
                    {avatar}
                    <div className="ml-4" style={{ lineHeight: '16px' }}>
                      <div
                        className="d-flex"
                        style={{ fontSize: 14 }}
                      >
                        {companyCode && (
                          <HighlightText
                            highlight={searchText}
                            text={companyCode}
                            style={{
                              color: 'red',
                              marginRight: 5,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          />
                        )}
                        <HighlightText
                          highlight={searchText}
                          text={info.companyName}
                        />
                      </div>
                      {contact.requestorId && !contact.isDeleted && isMe ? (
                        <div style={{ fontSize: 14, color: 'gray' }}>
                          <HighlightText
                            highlight={searchText}
                            style={{
                              fontSize: 14,
                              color: 'gray',
                            }}
                            text={`${info.firstName} ${info.lastName} `}
                          />
                          (<HighlightText
                            highlight={searchText}
                            style={{
                              fontSize: 14,
                              color: 'red',
                            }}
                            text={`${info.email}`}
                          />)
                        </div>
                      ) : (
                        <HighlightText
                          className={`${isVendor ? 'd-md-down-none' : ''}`}
                          highlight={searchText}
                          style={{
                            fontSize: 14,
                            color: 'gray',
                          }}
                          text={`${info.firstName} ${info.lastName} (${info.email})`}
                        />
                      )}
                      {!isVendor && Boolean(lengthOfMembers) && (
                        <div className="d-md-down-none">
                          <span className="d-flex" style={{ alignItems: 'center', fontSize: '12px', whiteSpace: 'nowrap' }}>
                            <Group style={{ color: 'rgba(0, 0, 0, 0.5)' }} />&nbsp;
                            {contact.buyerProfile.members.length} {formatMessage('{memberCount, plural, one {Member} other {Members}}', { memberCount: contact.buyerProfile.members.length })}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Options */}
                  <div className={`store-card-options-customer d-flex d-md-down-none col-md-6 ${contact.requestorId && !contact.isDeleted && isMe ? 'no-padding' : ''}`} style={{ alignItems: 'center', justifyContent: 'left', flexGrow: 8 }}>
                    {(contact.requestorId && !contact.isDeleted) ? (
                      <div className={`vendor-requests card-option ${contact.requestorId && !contact.isDeleted && isMe ? 'no-padding' : ''}`}>
                        <div className="request-pane d-md-down-none">
                          {
                            isMe && <span className="request-string d-md-down-none">{formatMessage('You Sent a Contact Request')}</span>
                          }
                          <Tooltip tooltip={isMe ? formatMessage('Request Sent') : formatMessage('Request Received')}>
                            <span className="pending">
                              <Pending
                                color={grey700}
                                style={{ transform: 'scale(1.2)' }}
                              />
                            </span>
                          </Tooltip>
                        </div>
                        {
                          isMe && (
                            <ConfirmAction
                              action={this.resend}
                              description={formatMessage('Do you really want to resend an invitation?')}
                            >
                              <Button
                                className="accept"
                                variant="contained"
                              >
                                {formatMessage('Resend')}
                              </Button>
                            </ConfirmAction>
                          )
                        }
                        {!isMe && (
                          <Button
                            className="accept"
                            disabled={contactRequesting}
                            onClick={this.accept}
                            variant="contained"
                          >
                            {formatMessage('Accept')}
                          </Button>
                        )}
                        <ConfirmAction
                          action={this.removeContactInfo}
                          description={formatMessage('Do you really want to cancel this invitation?')}
                        >
                          <IconButton style={{ padding: 5 }}>
                            <Delete color={grey700} />
                          </IconButton>
                        </ConfirmAction>
                      </div>
                    ) : (
                      <Fragment>
                        <div style={{ alignItems: 'center', paddingRight:'15px' }} className="d-flex card-option col-md-2 no-padding">
                          { contact.isDeleted ? (
                            isMe ? (
                              <div className="order-last">
                                <Button
                                  onClick={this.activate}
                                  variant="contained"
                                >
                                  {formatMessage('Unblock')}
                                </Button>
                              </div>
                            ) : (
                              <div style={{width:'100%'}}>
                                <InvoiceBadge type="deactivated" style={{whiteSpace: 'normal' }}>
                                  {isVendor ? formatMessage('Blocked by vendor') : formatMessage('Blocked by customer')}
                                </InvoiceBadge>
                              </div>
                            )
                          ) : ((get(contact, 'sellerProfile.isOff') && !isConsumer) || (get(contact, 'sellerProfile.isConsumerOff') && isConsumer)) && isVendor && (
                            <div style={{ width: '100%' }}>
                              <InvoiceBadge type="deactivated" style={{ whiteSpace: 'normal' }}>
                                {formatMessage('Vendor is Closed') }
                              </InvoiceBadge>
                            </div>
                          )}
                        </div>
                        <div className="d-md-down-none card-option col-md-2 no-padding">
                          <InvoiceBadge type={buyerRole === 'Seller' ? 'wholesale' : buyerRole === 'Buyer' ? 'restaurant' : buyerRole === 'Consumer' ? isConsumer ? 'retail' : 'consumer' : buyerRole.toLowerCase()}>
                            {formatMessage(buyerRole === 'Seller' ? 'Wholesale' : buyerRole === 'Buyer' ? 'Restaurant' : buyerRole === 'Consumer' ? isConsumer ? 'Retail' : 'Consumer' : buyerRole) }
                          </InvoiceBadge>
                        </div>
                        <div className="d-md-down-none card-option col-md-2 no-padding">
                          {!noAutoPay && (isDeactivated || !contact.requestorId) && (buyerRole !== 'Consumer') && (
                            <SelectField
                              classes={{
                                item: { root: classes.netModeSelectItem },
                                root: { root: classes.netModeSelect },
                                select: {
                                  select: classes.netModeSelectLabel,
                                  selectMenu: classnames(
                                    classes.netModeSelectMenu,
                                    {
                                      auto: classes.autoMenu,
                                      'manual-': classes.manualMenu,
                                    }[contact.netMode.substr(0, 7) || 'auto'] || classes.netMenu,
                                  ),
                                  icon: isVendor ? classes.iconHide : classes.iconShow,
                                },
                              }}
                              defaultValue={contact.netMode || 'auto'}
                              disabled={readOnly || isDeactivated || isVendor}
                              name="net-mode"
                              label="Terms"
                              options={netModeOptions}
                              onChange={this.handleNetModeChange}
                              style={{ backgroundColor: 'gray' }}
                            />
                          )}
                        </div>
                        {showPaymentMethodDropDown && !noAutoPay &&
                        (isDeactivated || !contact.requestorId) && (
                          <div className="card-option">
                            <SelectField
                              classes={{
                                item: { root: classes.netModeSelectItem },
                                root: { root: classes.netModeSelect },
                                select: {
                                  select: classes.netModeSelectLabel,
                                  selectMenu: classnames(
                                    classes.netModeSelectMenu,
                                    {
                                      all: classes.autoMenu,
                                      card: classes.autoMenu,
                                      ach: classes.autoMenu,
                                      coin: (contact.netMode.substr(0, 7) || 'auto') === 'manual-'
                                        ? classes.manualMenu
                                        : classes.autoMenu,
                                    }[contact.payMode || 'all'] || classes.netMenu,
                                  ),
                                  icon: isVendor ? classes.iconHide : classes.iconShow,
                                },
                              }}
                              label="Method"
                              defaultValue={contact.payMode || 'all'}
                              key={contact.payMode}
                              disabled={readOnly || isDeactivated || isVendor}
                              name="pay-mode"
                              options={payModeOptions}
                              onChange={this.handlePayModeChange}
                              style={{ backgroundColor: 'gray' }}
                            />
                          </div>
                        )}
                        <div className="discount-info d-md-down-none card-option col-md-1 no-padding" style={{ lineHeight: 1 }}>
                          {(isDeactivated || !contact.requestorId) &&
                            contact.defaultDiscount > 0 && (
                            <Tooltip tooltip={formatMessage('Discount')}>
                              <Badge
                                type={
                                  contact.sellerProfile.isOff || contact.isDeleted ?
                                  'unavailable' : 'discount'
                                }>
                                {-contact.defaultDiscount}%
                              </Badge>
                            </Tooltip>
                          )}
                        </div>
                        {/* Truck */}
                        <div className="col-md-2 no-padding">
                          {(isDeactivated || !contact.requestorId) &&
                            contact.defaultDeliveryFee > 0 && (
                            <div className="discount-info d-flex card-option" style={{ color: green[400], lineHeight: 1 }}>
                              <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'flex-end' }}>
                                <LocalShipping />&nbsp;
                              </div>
                              <div style={{ alignItems: 'center', justifyContent: 'flex-end', fontWeight: 500 }}>
                                {formatMessage('fee')}&nbsp;
                                <span className="number" style={{ color: green[400] }}>
                                  ${contact.defaultDeliveryFee}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </Fragment>
                    )}

                    {/* Unpaid */}
                    <div className="d-md-down-none card-option col-md-2 no-padding" style={{ fontSize: '13px', lineHeight: 1 }}>
                      {Number(contact.unpaidBalance) > 0 && (
                        <Badge type="manual-pay" style={{ backgroundColor: '#4695ec', color: '#ffffff', fontWeight: 500 }}>
                          ${formatPrice(contact.unpaidBalance)}
                          &nbsp;-&nbsp;
                          <span>{formatMessage('Unpaid')}</span>
                        </Badge>
                      )}
                    </div>
                  </div>

                  { // Group
                  !(contact.requestorId && !contact.isDeleted) ? (
                    <div className="store-card-options-wrapper d-flex d-md-down-none col-md-2 no-padding" style={{ justifyContent: 'flex-end' }}>
                      {(isDeactivated || !contact.requestorId) && !isConsumer && (
                        <div
                          className="broad-cast-group-dropdown"
                          onClick={e => e.stopPropagation()}
                        >
                          <SelectField
                            classes={{
                              item: { root: classes.groupsSelectItem },
                              root: { root: classes.groupsSelectRoot },
                              select: {
                                select: classes.groupsSelectLabel,
                                selectMenu: classes.selectMenu,
                              },
                            }}
                            defaultValue={contact[isVendor ? 'sellerGroupName' : 'buyerGroupName']}
                            disabled={readOnly || isDeactivated}
                            label="Group"
                            name="group-list"
                            options={userBroadCastGroupsList}
                            onChange={this.handleGroupChange}
                          />
                        </div>
                      )}
                    </div>
                    ) : (undefined)
                  }
                </div>
              </div>
            }
            action={!(contact.requestorId && !contact.isDeleted && isMe) && (
              <IconButton
                aria-expanded={expanded}
                aria-label="Show more"
                onClick={() => this.expandChange(expanded)}
              >
                {expanded ? <CollapseIcon /> : <ExpandIcon />}
              </IconButton>
            )}
          />
          <Collapse
            in={expanded && (!contact.requestorId || contact.isDeleted)}
            timeout="auto"
            unmountOnExit
          >
            {/* SM and MD */}
            <div className="d-flex store-card-options-customer d-lg-up-none" style={{ alignItems: 'flex-end', flexFlow: 'row wrap' }}>

              {/* Vendor Code */}
              {isVendor && !isConsumer && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <div>{formatMessage('Vendor Code')}</div>
                  <FRInput
                    disabled={contact.isDeleted}
                    defaultValue={companyCode}
                    onBlur={({ target: { value } }) => this.updateCompanyCode(value)}
                    onKeyPress={({ keyCode, which, target: { value } }) =>
                      (which === 13 || keyCode === 13) && this.updateCompanyCode(value)}
                  />
                </div>
              )}

              {/* Company Code */}
              {!isVendor && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <div>{formatMessage('Company Code')}</div>
                  <FRInput
                    disabled={contact.isDeleted}
                    defaultValue={companyCode}
                    onBlur={({ target: { value } }) => this.updateCompanyCode(value)}
                    onKeyPress={({ keyCode, which, target: { value } }) =>
                      (which === 13 || keyCode === 13) && this.updateCompanyCode(value)}
                    style={{ marginTop: 7, marginRight: 5, fontSize: 18, width: 150 }}
                  />
                </div>
              )}

              {/* Group */}
              {(isDeactivated || !contact.requestorId) && !isConsumer && (
                <div className="broad-cast-group-dropdown" onClick={e => e.stopPropagation()} style={{ padding: '0 15px 15px 15px' }}>
                  <SelectField
                    classes={{
                      item: { root: classes.netModeSelectItem },
                      root: { root: classes.netModeSelect },
                      select: {
                        select: classes.groupsSelectLabel,
                        selectMenu: classes.selectMenu,
                      },
                    }}
                    defaultValue={contact[isVendor ? 'sellerGroupName' : 'buyerGroupName']}
                    disabled={readOnly || isDeactivated}
                    label="Group"
                    name="group-list"
                    options={userBroadCastGroupsList}
                    onChange={this.handleGroupChange}
                  />
                </div>
              )}

              {/* Discount */}
              {!isVendor && discountInput && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <FRInput
                    defaultValue={discount}
                    disabled={readOnly || contact.isDeleted === true}
                    max={100}
                    min={0}
                    onBlur={({ target: { value } }) => this.updateDiscount(value, false)}
                    onKeyPress={({ keyCode, which, target: { value } }) =>
                      (which === 13 || keyCode === 13) && this.updateDiscount(value, false)}
                    ref={(c) => { this.discountInput = c; }}
                    style={{ padding: 5, fontSize: 18, width: 150 }}
                    type="number"
                  />
                </div>
              )}
              {!isVendor && !discountInput && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <span>{formatMessage('Set Discount Tiers')}</span>
                  <SelectField
                    classes={{
                      root: { root: classes.tiersSelectRoot },
                      select: {
                        select: classes.tiersSelectLabel,
                        icon: classes.selectIcon,
                      },
                    }}
                    disabled={readOnly || contactRequesting || contact.isDeleted === true}
                    fullWidth
                    key={discount}
                    name="group-list"
                    onChange={this.updateDiscount}
                    options={compact([
                      discount % 5 === 0 && discount < 20 && discount >= 0 ? null : { label: `${discount}%`, value: discount },
                      { label: 'None', value: 0 },
                      { label: '5%', value: 5 },
                      { label: '10%', value: 10 },
                      { label: '15%', value: 15 },
                      { label: 'Custom', value: 'custom' },
                      contactRequesting ? { label: '...', value: 'loading' } : null,
                    ])}
                    value={contactRequesting ? 'loading' : discount}
                  />
                </div>
              )}

              {/* Terms */}
              {!noAutoPay && (isDeactivated || !contact.requestorId) && !isConsumer && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <SelectField
                    classes={{
                      item: { root: classes.netModeSelectItem },
                      root: { root: classes.netModeSelect },
                      select: {
                        select: classes.netModeSelectLabel,
                        selectMenu: classnames(
                          classes.netModeSelectMenuMobile,
                          {
                            auto: classes.autoMenu,
                            'manual-': classes.manualMenu,
                          }[contact.netMode.substr(0, 7) || 'auto'] || classes.netMenu,
                        ),
                        icon: isVendor ? classes.iconHide : classes.iconShow,
                      },
                    }}
                    defaultValue={contact.netMode || 'auto'}
                    disabled={readOnly || isDeactivated || isVendor}
                    name="net-mode"
                    label="Terms"
                    options={netModeOptions}
                    onChange={this.handleNetModeChange}
                    style={{ backgroundColor: 'gray' }}
                  />
                </div>
              )}

              {/* Delivery Free */}
              {!isVendor && (
                <div style={{ marginLeft: 5, padding: '0 15px 15px 15px' }}>
                  <div>{formatMessage('Set Delivery Fee')}</div>
                  <FRInput
                    defaultValue={deliveryFee}
                    disabled={readOnly || contactRequesting || contact.isDeleted === true}
                    onBlur={({ target: { value } }) => this.updateDeliveryFee(value)}
                    onKeyPress={({ keyCode, which, target: { value } }) =>
                      (which === 13 || keyCode === 13) && this.updateDeliveryFee(value)}
                    style={{ marginTop: 7, marginRight: 5, fontSize: 18, width: 150 }}
                    type="number"
                  />
                </div>
              )}

              {/* Discount */}
              {(isDeactivated || !contact.requestorId) &&
                contact.defaultDiscount > 0 && (
                  <div style={{ padding: '0 15px 15px 15px' }}>
                    <div className="discount-info" style={{ lineHeight: 1 }}>
                      <Tooltip tooltip={formatMessage('Discount')}>
                        <Badge
                          type={
                            contact.sellerProfile.isOff || contact.isDeleted ?
                            'unavailable' : 'discount'
                          }>
                          %&nbsp;{-contact.defaultDiscount}
                        </Badge>
                      </Tooltip>
                    </div>
                  </div>
                )
              }

              {/* Members */}
              {!isVendor && Boolean(lengthOfMembers) && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <span className="d-flex" style={{ alignItems: 'center', fontSize: '12px', whiteSpace: 'nowrap' }}>
                    <Group style={{ color: 'rgba(0, 0, 0, 0.5)' }} />&nbsp;
                    {contact.buyerProfile.members.length} {formatMessage('{memberCount, plural, one {Member} other {Members}}', { memberCount: contact.buyerProfile.members.length })}
                  </span>
                </div>
              )}
             
              {/* More info */}
              {(contact.requestorId && !contact.isDeleted) ? (
                <div className="vendor-requests" style={{ padding: '0 15px 15px 15px' }}>
                  <div className="request-pane d-md-down-none">
                    {
                      isMe && <span className="request-string d-md-down-none">{formatMessage('You Sent a Contact Request')}</span>
                    }
                    <Tooltip tooltip={isMe ? formatMessage('Request Sent') : formatMessage('Request Received')}>
                      <span className="pending">
                        <Pending
                          color={grey700}
                          style={{ transform: 'scale(1.2)' }}
                        />
                      </span>
                    </Tooltip>
                  </div>
                  {
                    isMe && (
                      <ConfirmAction
                        action={this.resend}
                        description={formatMessage('Do you really want to resend an invitation?')}
                      >
                        <Button
                          className="accept"
                          variant="contained"
                        >
                          {formatMessage('Resend')}
                        </Button>
                      </ConfirmAction>
                    )
                  }
                  {!isMe && (
                    <Button
                      className="accept"
                      disabled={contactRequesting}
                      onClick={this.accept}
                      variant="contained"
                    >
                      {formatMessage('Accept')}
                    </Button>
                  )}
                  <ConfirmAction
                    action={this.removeContactInfo}
                    description={formatMessage('Do you really want to cancel this invitation?')}
                  >
                    <IconButton style={{ padding: 5 }}>
                      <Delete color={grey700} />
                    </IconButton>
                  </ConfirmAction>
                </div>
              ) : (
                <Fragment>
                  <div className="d-flex store-card-options-wrapper">
                    {(contact.isDeleted || get(contact, 'sellerProfile.isOff')) && (
                      <div style={{ alignItems: 'flex-end', flexFlow: 'row wrap', padding: '0 15px 15px 15px' }} className="d-flex">
                        {contact.isDeleted && isMe && (
                          <InvoiceBadge type="deactivated">
                            {formatMessage('Blocked')}
                          </InvoiceBadge>
                        )}
                        {contact.isDeleted && !isMe && (
                          <InvoiceBadge type="deactivated">
                            {isVendor ? formatMessage('Blocked by vendor') : formatMessage('Blocked by customer')}
                          </InvoiceBadge>
                        )}
                        {get(contact, 'sellerProfile.isOff') && (
                          <InvoiceBadge type="deactivated">
                            {isVendor ? isMobile ? formatMessage('Closed') : formatMessage('Vendor Is Closed') : formatMessage('Your Store Is Closed')}
                          </InvoiceBadge>
                        )}
                      </div>
                    )}
                    {!noAutoPay && (isDeactivated || !contact.requestorId) && (
                      <div className="d-md-down-none" style={{ padding: '0 15px 15px 15px' }}>
                        <SelectField
                          classes={{
                            item: { root: classes.netModeSelectItem },
                            root: { root: classes.netModeSelect },
                            select: {
                              select: classes.netModeSelectLabel,
                              selectMenu: classnames(
                                classes.netModeSelectMenu,
                                {
                                  auto: classes.autoMenu,
                                  'manual-': classes.manualMenu,
                                }[contact.netMode.substr(0, 7) || 'auto'] || classes.netMenu,
                              ),
                              icon: isVendor ? classes.iconHide : classes.iconShow,
                            },
                          }}
                          defaultValue={contact.netMode || 'auto'}
                          disabled={readOnly || isDeactivated || isVendor}
                          name="net-mode"
                          label="Terms"
                          options={netModeOptions}
                          onChange={this.handleNetModeChange}
                          style={{ backgroundColor: 'gray' }}
                        />
                      </div>
                    )}
                    {showPaymentMethodDropDown && !noAutoPay &&
                    (isDeactivated || !contact.requestorId) && (
                      <div style={{ padding: '0 15px 15px 15px' }}>
                        <SelectField
                          classes={{
                            item: { root: classes.netModeSelectItem },
                            root: { root: classes.netModeSelect },
                            select: {
                              select: classes.netModeSelectLabel,
                              selectMenu: classnames(
                                classes.netModeSelectMenu,
                                {
                                  all: classes.autoMenu,
                                  card: classes.autoMenu,
                                  ach: classes.autoMenu,
                                  coin: (contact.netMode.substr(0, 7) || 'auto') === 'manual-'
                                    ? classes.manualMenu
                                    : classes.autoMenu,
                                }[contact.payMode || 'all'] || classes.netMenu,
                              ),
                              icon: isVendor ? classes.iconHide : classes.iconShow,
                            },
                          }}
                          label="Method"
                          defaultValue={contact.payMode || 'all'}
                          key={contact.payMode}
                          disabled={readOnly || isDeactivated || isVendor}
                          name="pay-mode"
                          options={payModeOptions}
                          onChange={this.handlePayModeChange}
                          style={{ backgroundColor: 'gray' }}
                        />
                      </div>
                    )}
                    {
                      (isDeactivated || !contact.requestorId) &&
                      contact.defaultDiscount > 0 && !isMobile && (
                        <div className="discount-info d-md-down-none" style={{ padding: '0 15px 15px 15px', lineHeight: 1 }}>
                          <Tooltip tooltip={formatMessage('Discount')}>
                            <Badge
                              type={
                                contact.sellerProfile.isOff || contact.isDeleted ?
                                'unavailable' : 'discount'
                              }>
                              %&nbsp;{-contact.defaultDiscount}
                            </Badge>
                          </Tooltip>
                        </div>
                      )
                    }
                    {
                      (isDeactivated || !contact.requestorId) &&
                        contact.defaultDeliveryFee > 0 && (
                        <div className="discount-info d-flex align-items-center" style={{ color: green[400], padding: '0 15px 15px 15px', lineHeight: 1 }}>
                          <div style={{ marginTop: 0, lineHeight: 1 }}>
                            <LocalShipping />&nbsp;
                          </div>
                          <div>
                            <span className="number">
                              ${contact.defaultDeliveryFee}
                            </span>
                            &nbsp;{formatMessage('fee')}
                          </div>
                        </div>
                      )
                    }
                  </div>
                </Fragment>
              )}

              {/* Unpaid */}
              {Number(contact.unpaidBalance) > 0 && (
                <div style={{ fontSize: '13px', lineHeight: 1, padding: '0 15px 15px 15px' }}>
                  <Badge type="manual-pay" style={{ backgroundColor: '#4695ec', color: '#ffffff', fontWeight: 500 }}>
                    ${formatPrice(contact.unpaidBalance)}
                    &nbsp;-&nbsp;
                    <span>{formatMessage('Unpaid')}</span>
                  </Badge>
                </div>
              )}

              {/* Block button */}
              {!(isDeactivated || contact.requestorId) && (
                <div style={{ padding: '0 15px 15px 15px' }}>
                  <ConfirmAction
                    action={this.removeContactInfo}
                    description={formatMessage('Do you really want to block this vendor?')}
                  >
                    <Button
                      classes={{ label: classes.textButtonLabel }}
                      disabled={readOnly}
                    >
                      {formatMessage('Block')}
                    </Button>
                  </ConfirmAction>
                </div>
              )}
            </div>
            {cardCover}
            {this.renderCardContent(isVendor, companyCode, lengthOfMembers, avatar)}
          </Collapse>
        </Card>
      </Element>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('orders', 'order')(state, 'order'),
  ...selectState('orders', 'orders')(state, 'orders'),
  ...selectState('contacts', 'contactReinvite')(state, 'contactReinvite'),
  ...selectState('options', 'globals')(state, 'globals'),
});

export default compose(
  setDisplayName('ContactCard'),
  connect(
    mapStateToProps,
    dispatchRestMaker([
      [buyersAcceptActions, 'buyersAccept'],
      [ordersActions, 'order'],
      [sellersAcceptActions, 'sellersAccept'],
      [contactsReinviteActions, 'contactReinvite'],
    ]),
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(ContactCard);
